import { getThemeColors, getUSANumberFormat } from "app/utils/utils";
import IPPageNumber from "../IPPageNuber";
import HexagonImg from "../../images/hexagonImg.png";
import { getSessionStore } from "app/utils/sessionStore";
import { getColorVariations } from "app/utils/colorUtils";

const AppendixTable = ({
  tableData,
  tableHeaders,
  secondaryColor,
}: {
  tableData: any;
  tableHeaders: any;
  secondaryColor: any;
}) => {
  const getVariationColor = getColorVariations(secondaryColor, tableHeaders.length);
  const variationColor = getVariationColor.reverse();

  return (
    <table className="w-full border-collapse">
      <thead>
        <tr>
          {tableHeaders?.map(({ header }: any, index: any) => (
            <th
              key={header}
              className="p-1 text-center font-semibold text-white border-2 border-white"
              style={{ backgroundColor: variationColor[index], fontSize: "6.53px" }}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData?.map((policy: any, index: any) => (
          <tr
            key={index}
            style={{ backgroundColor: "#EEEEEE", color: "#000000", fontSize: "7.07px" }}
          >
            <td className="p-1 text-center border-2 border-white">{policy?.planYear}</td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.clientPremium, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.clientAdminFee, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.clientInterestPayment, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.clientOriginationFees, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.lenderPremium, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.totalPolicyPremium, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.eoyOutstandingLoanBalance, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.stressTestedCollateral, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.estimatedLoanPayoffOrIncome, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.illustratedPlanAccumulatedValue, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.illustratedPlanSurrenderValue, false)}
            </td>
            <td className="p-1 text-center border-2 border-white">
              ${getUSANumberFormat(policy?.illustratedPlanDB, false)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const PFIappendix = ({
  appendixTableData,
  pageNumber,
  newPage,
  insuranceCompanyName,
}: {
  appendixTableData?: any;
  pageNumber: string | number;
  newPage?: boolean;
  insuranceCompanyName?: string;
}) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { secondaryColor } = getThemeColors(branding);

  const secondTable = [
    { header: "Plan Year" },
    { header: "Client Premium" },
    { header: "Client Admin Fee" },
    { header: "Client Interest Payment" },
    { header: "Client Origination Fees" },
    { header: "Finance Premium" },
    { header: "Total Policy Premium" },
    { header: "EOY Outstanding Financing Balance" },
    { header: "Stress Tested Collateral (+Surplus/-Shortfall)" },
    { header: "Estimated Loan Payoff/ Income" },
    { header: "Illustrated Plan Accumulated Value" },
    { header: "Illustrated Plan Surrender Value" },
    { header: "Illustrated Plan DB" },
  ];

  //   const getVariationColorFirstTable = getColorVariations(secondaryColor, firstTable.length);
  //   const variationColorFirstTable = getVariationColorFirstTable.reverse();

  const renderContent = () => {
    if (newPage) {
      return (
        <div className="px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
          <AppendixTable
            tableData={appendixTableData}
            tableHeaders={secondTable}
            secondaryColor={secondaryColor}
          />
        </div>
      );
    }
    return (
      <div className="px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
        <div className="text-xl font-bold mb-3 text-center interactive-proposal-text conthrax-font">
          Appendix
        </div>
        <div className="mb-3">
          <p className="mb-2 text-base conthrax-font" style={{ color: "#495057" }}>
            Policy 1 – {insuranceCompanyName} – Please see full insurance company illustration
          </p>
        </div>
        <AppendixTable
          tableData={appendixTableData}
          tableHeaders={secondTable}
          secondaryColor={secondaryColor}
        />
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full relative min-h-screen">
      <div className="relative z-20">{renderContent()}</div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{
            backgroundImage: `url(${HexagonImg})`,
            backgroundSize: "cover",
          }}
        />
        <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default PFIappendix;
